import { render, staticRenderFns } from "./ebiEditbar.vue?vue&type=template&id=6c6e9b28"
import script from "./ebiEditbar.vue?vue&type=script&lang=ts"
export * from "./ebiEditbar.vue?vue&type=script&lang=ts"
import style0 from "./ebiEditbar.vue?vue&type=style&index=0&id=6c6e9b28&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports